






















































import Vue from 'vue';

export default Vue.extend({
    props: {
        value: {
            type: Boolean,
        },
        userId: {
            type: Number,
        },
        title: {
            type: String,
        },
    },
    computed: {},
    data() {
        return {
            show: false,
            loading: false,
            formData: {
                userId: this.userId,
                valueUsd: null,
                comment: null,
            },
        };
    },
    methods: {
        async handleSubmit() {
            // @ts-ignore
            if (this.$refs.setupModal.validate()) {
                try {
                    this.loading = true;
                    const response = await this.$hipApi.addCreditToUser(this.formData);
                    this.closeForm();
                    this.$notifier.showSuccess(`Credit has been added - id: ${response.created}`);
                    this.$emit('onAddCredit');
                    this.show = false;
                } catch (err) {
                    console.log(err);
                    this.$notifier.showError('Failed to add credit');
                }
                this.loading = false;
            }
        },
        closeForm() {
            this.$emit('input', false);
            // @ts-ignore
            this.$refs.setupModal.reset();
            //need to update credit table and balance
        },
        handleCancel() {
            // @ts-ignore
            this.$refs.setupModal.resetFields();
            this.show = false;
        },
    },
    created() {
        this.show = true;
    },
});
